import { L } from "@/i18n/routing";
import { useDict } from "@/i18n/useDict";

const Footer = () => {
  const { dict } = useDict();
  const f = dict.footer;
  return (
    <footer className="py-10 px-6 border-t border-border">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-8">
          {/* Left Section */}
          <div>
            <p className="text-sm text-muted-foreground mb-4">{f.rights}</p>
          </div>

          {/* Center Section - Links */}
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <L to="/#module" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{f.modules}</L>
            <L to="/#preturi" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{f.pricing}</L>
            <L to="/blog" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{dict.blog.navLabel}</L>
            <L to="/#contact" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{f.contact}</L>
            <a href="mailto:contact@optify.ro" className="text-sm text-muted-foreground hover:text-foreground transition-colors">contact@optify.ro</a>
          </div>

          {/* Right Section - ANPC and SOL Icons */}
          <div className="flex items-center gap-4">
            <a
              href="https://reclamatiisal.anpc.ro/"
              target="_blank"
              rel="noopener noreferrer"
              title={f.anpcTitle}
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <img src="/ANPC.png" alt="ANPC" className="h-12" />
            </a>
            <a
              href="https://europa.eu/youreurope/business/dealing-with-customers/solving-disputes/alternative-dispute-resolution/index_ro.htm"
              target="_blank"
              rel="noopener noreferrer"
              title={f.solTitle}
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <img src="/SOL.png" alt="SOL" className="h-12" />
            </a>
          </div>
        </div>

        {/* Policy Links */}
        <div className="flex flex-wrap items-center justify-center gap-4 pt-6 border-t border-border">
          <L to="/privacy" className="text-xs text-muted-foreground hover:text-foreground transition-colors">{f.privacy}</L>
          <span className="text-muted-foreground">&bull;</span>
          <L to="/cookies" className="text-xs text-muted-foreground hover:text-foreground transition-colors">{f.cookies}</L>
          <span className="text-muted-foreground">&bull;</span>
          <L to="/terms" className="text-xs text-muted-foreground hover:text-foreground transition-colors">{f.terms}</L>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
